import moment from 'moment-timezone';
import { api } from '@/f1/service';
import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Language from './language';

//restful api
// import { wsfinder as wf } from '@/f1/service/api';

//i18n_data
import _i18n_data from './i18n_data'
import i18n_data from '@/component/i18n_data';


export default {
  components: { vueDropzone, Language },
  data: () => {
    return {
      file : undefined,
      files:[],
    }
  },
  computed: {
    fields() { return _i18n_data.i18n_fields[this.i18n || 'EN'] },
    startRow : function() {
      return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage;
    }
  },
  methods: {
    async bs_file(file) {
      let fr = new FileReader();
      let f = file.target.files[0];
      if(!f) { return; }
      if(f.size > 5242880) { this.$toastr.w(`${_i18n_data._i18n_warning.file_size[this.i18n]}`); return; }
      if(f.size == 0) { this.$toastr.e(`${_i18n_data._i18n_error.file_size[this.i18n]}`); return;}
      fr.onload = () => {
        let model = Object.assign(
          this.file,
          { 'content' : fr.result, 'description' : ''},
          { 'path' : this.file.name, 'index' : this.files.length }
          );
        this.files.push(model);
      }
      fr.readAsDataURL(f);
    },
    async send(i) {
      let f = JSON.parse(JSON.stringify(this.files[i]))
      location.hostname == 'localhost' ?  console.info(f) : '';
      try {
        let rs = await api.wsfinder.WSFinder_Call('report', 'insert', f)
        //let rs = await wf.report.insert(f)
        if(!rs.error) {
          this.remove(i); this.$toastr.s(`${_i18n_data._i18n_success.reception[this.i18n]}`);
        } else {
          this.$toastr.s(`${_i18n_data._i18n_error.report_failed[this.i18n]}`, `${i18n_data._i18n_error.failed[this.i18n]}`);
        }
        this.$emit('refresh')

      }catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText)  }
    },
    remove(i) { this.files.splice(i, 1); this.refresh();},
    reset() { this.files = []; this.refresh(); },
    refresh() { console.log('refresh'); this.$refs._list.refresh();},
  },
  created: function() {   console.log('report.list.vue', 'created'); },
  destroyed: function() { console.log('report.list.vue', 'destroyed'); },
  mounted: function() { console.log('report.list.vue', 'mounted'); },
}
